import React from 'react';

interface PaymentSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  leadId: number;
}

const PaymentSwitch: React.FC<PaymentSwitchProps> = ({ checked, onChange, leadId }) => {
  return (
    <label className="payment-switch">
      <input 
        type="checkbox" 
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <div className="switch-track"></div>
    </label>
  );
}

export default PaymentSwitch;
